/*
 * @Description: 
 * @Author: shenkaiyao
 * @Date: 2020-09-29 10:34:48
 * @LastEditors: 
 * @LastEditTime: 2020-09-29 10:35:33
 */
import InfoTabs from './infoTabs';

export default InfoTabs